module.exports = __webpack_public_path__ + "static/media/california.7ca1f9e9.jpeg";